// import _ from 'lodash';
import debug from '../../services/debug';
import {
  SET_ACTIONAPPROVALDOCID_ROUTE_REQUESTED,
  // SET_ACTIONAPPROVALDOC_REDIRECT_ABORTED,
  SET_ACTIONAPPROVALDOCID_ROUTE_COMPLETED,
  SET_ACTIONAPPROVALDOCID_ROUTE_FAILED,
} from './types';

const set = async (ActionApprovalDocID) => async (dispatch) => {
  // const { contacts } = getState();

  // const contact = contacts.get('set');
  // if (_.isEmpty(contact) && contact.ContactID === 0) {
  //     return dispatch({
  //         type: SET_ACTIONAPPROVALDOC_REDIRECT_ABORTED,
  //     });
  // }

  dispatch({
    type: SET_ACTIONAPPROVALDOCID_ROUTE_REQUESTED,
  });

  try {
    dispatch({
      type: SET_ACTIONAPPROVALDOCID_ROUTE_COMPLETED,
      payload: ActionApprovalDocID,
    });
  } catch (err) {
    debug(SET_ACTIONAPPROVALDOCID_ROUTE_FAILED, err);

    dispatch({
      type: SET_ACTIONAPPROVALDOCID_ROUTE_FAILED,
      payload: err,
    });
  }
};

export default set;
